export const PAYMENT_TYPE = {
    IDEAL: 'ideal',
    CASH: 'cash',
    DISCOUNT: 'discount',
    BUNDLE: 'bundle',
    SUBSCRIPTION: 'subscription',
};